import { kgToLbs, lbsToKg, round } from "../dataStore"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    targetWeightKg: null,
    targetWeightLbs: null,
  },

  onInit() {
    Alpine.effect(() => {
      if (this.store.isMetric) {
        this.formValues.targetWeightLbs = round(kgToLbs(this.formValues.targetWeightKg))
      } else {
        this.formValues.targetWeightKg = round(lbsToKg(this.formValues.targetWeightLbs))
      }
    })

    const idealWeightKg = this.store.idealWeight
    const idealWeightLbs = round(kgToLbs(this.store.idealWeight))

    if (this.store.isMetric && !this.formValues.targetWeightKg) {
      this.formValues.targetWeightKg = this.store.idealWeightRange.includes(idealWeightKg)
        ? idealWeightKg
        : this.store.idealWeightRange[0]
    } else if (this.store.isImperial && !this.formValues.targetWeightLbs) {
      this.formValues.targetWeightLbs = this.store.idealWeightRange.includes(idealWeightLbs)
        ? idealWeightLbs
        : this.store.idealWeightRange[0]
    }
  },

  processFormValues() {
    return {
      targetWeightKg: parseInt(this.formValues.targetWeightKg),
      targetWeightLbs: parseInt(this.formValues.targetWeightLbs),
    }
  },
})
